import { PublicLink } from '@/components/PublicLink';
import { cn } from '@/lib/utils';

export type DatasetCatalogView = 'user' | 'public';

const DATASET_CATALOG_LINKS: Array<{
  view: DatasetCatalogView;
  href: string;
  label: string;
}> = [
  { view: 'user', href: '/datasets/my', label: 'Ваши датасеты' },
  { view: 'public', href: '/datasets', label: 'Открытые датасеты' },
];

export function DatasetCatalogSwitch({ activeView }: { activeView: DatasetCatalogView }) {
  return (
    <nav
      aria-label="Разделы датасетов"
      className="inline-flex flex-wrap items-center gap-1 rounded-full border border-[color:var(--site-border-soft)] bg-[var(--site-surface)] p-1 shadow-[var(--site-shadow-soft)]"
    >
      {DATASET_CATALOG_LINKS.map((link) => {
        const active = link.view === activeView;
        return (
          <PublicLink
            key={link.view}
            href={link.href}
            aria-current={active ? 'page' : undefined}
            className={cn(
              'inline-flex min-h-10 items-center justify-center whitespace-nowrap rounded-full px-4 text-sm font-medium transition-colors',
              active
                ? 'bg-[var(--site-primary-fill)] text-[var(--site-primary-text)] shadow-[var(--site-shadow-button)]'
                : 'text-[var(--site-ink)] hover:bg-[var(--site-surface-muted)] hover:text-[var(--site-ink-strong)]',
            )}
          >
            {link.label}
          </PublicLink>
        );
      })}
    </nav>
  );
}
